import { Button } from '@calendly/ui/components/button';
import { Sheet } from '@calendly/ui/components/sheet';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const modalContainerIsPhoneCss = "m1099gp8";
const modalContainerCss = "m1q4ohbg";
export const ModalContainer = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <Sheet ref={ref} {...props} className={classNames(modalContainerCss, {
    [modalContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const headerCss = "h1i2liya";
export const Header = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerCss, props.className)} />;
});
const viewContainerCss = "vzw9dgj";
export const ViewContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(viewContainerCss, props.className)} />;
});
const tableContainerCss = "t1ow7mt3";
export const TableContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(tableContainerCss, props.className)} />;
});
const wideFooterButtonCss = "w102bajw";
export const WideFooterButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(wideFooterButtonCss, props.className)} />);

require("./styles.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");